import { render, staticRenderFns } from "./Actions.vue?vue&type=template&id=0ed15359&scoped=true"
import script from "./Actions.vue?vue&type=script&lang=ts"
export * from "./Actions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed15359",
  null
  
)

export default component.exports